import { useEffect, useState } from "preact/hooks";
import qrcode from "qrcode-generator";
import { Modal } from "./Modal";
import { active } from "../../lib/state";
import { encodeSchedule } from "../../lib/share";
import { shareSnapshot, publishSchedule, updatePublished, calUrl, googleCalUrl } from "../../lib/api";
import { flash } from "../../store";

const PUB_KEY = "ss.published.v1";
type Published = Record<string, { id: string; token: string }>;
const getPub = (): Published => JSON.parse(localStorage.getItem(PUB_KEY) || "{}");

function Qr({ text }: { text: string }) {
  const q = qrcode(0, "M");
  q.addData(text);
  q.make();
  return <img class="qr" alt="QR" src={q.createDataURL(4, 2)} />;
}

export function ShareDialog({ onClose }: { onClose: () => void }) {
  const sched = active.value;
  const [hashLink, setHashLink] = useState("");
  const [short, setShort] = useState("");
  const [pub, setPub] = useState(getPub()[sched.name]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { encodeSchedule(sched).then((tok) => setHashLink(`${location.origin}/s/${tok}`)); }, []);
  const best = short || hashLink;
  const copy = (s: string) => { navigator.clipboard.writeText(s); flash("Link kopiran"); };

  async function makeShort() {
    setBusy(true);
    try { const r = await shareSnapshot(sched); setShort(`${location.origin}/s/${r.id}`); } catch (e) { flash(`Kratki link nije uspio: ${(e as Error).message}`); } finally { setBusy(false); }
  }
  async function publish() {
    setBusy(true);
    try {
      const all = getPub();
      const cur = all[sched.name];
      const r = cur ? await updatePublished(cur.id, cur.token, sched) : await publishSchedule(sched);
      all[sched.name] = { id: r.id, token: (r as { token?: string }).token ?? cur!.token };
      localStorage.setItem(PUB_KEY, JSON.stringify(all));
      setPub(all[sched.name]);
      flash(cur ? "Objavljeni raspored ažuriran" : "Raspored objavljen");
    } catch (e) { flash(`Objava nije uspjela: ${(e as Error).message}`); } finally { setBusy(false); }
  }
  const feed = pub ? calUrl(pub.id) : "";
  return (
    <Modal title="Podijeli raspored" onClose={onClose}>
      <p class="note">Link otvara kopiju ovog rasporeda (predmeti, grupe, izmjene i vlastiti događaji), npr. na telefonu ili kod prijatelja.</p>
      <div class="linkbox"><input readOnly value={best} onFocus={(e) => (e.target as HTMLInputElement).select()} /><button class="btn sm" onClick={() => copy(best)}>Kopiraj</button></div>
      <div class="row">
        {!short && <button class="btn ghost sm" disabled={busy} onClick={makeShort}>Napravi kratki link</button>}
        {navigator.share && <button class="btn ghost sm" onClick={() => navigator.share({ title: sched.name, url: best })}>Podijeli…</button>}
      </div>
      {best && best.length < 1800 && <Qr text={best} />}
      <h5 style="font:600 11px var(--mono);letter-spacing:.14em;text-transform:uppercase;color:var(--ink-3);margin:1.2rem 0 .4rem">Kalendar koji se sam ažurira</h5>
      <p class="note">Objavi raspored i dobit ćeš link za pretplatu u kalendaru. Kad fakultet objavi novu verziju rasporeda, ili kad ti nešto promijeniš i ponovo objaviš, kalendar se sam osvježi. Google Calendar osvježava pretplate sporo (12 do 24 sata), Apple brže.</p>
      <div class="row"><button class="btn sm" disabled={busy} onClick={publish}>{pub ? "Ažuriraj objavljeni raspored" : "Objavi i dobij kalendar link"}</button></div>
      {pub && (
        <>
          <div class="linkbox"><input readOnly value={feed} /><button class="btn sm" onClick={() => copy(feed)}>Kopiraj</button></div>
          <div class="row">
            <a class="btn ghost sm" style="text-decoration:none" href={feed.replace(/^https?:/, "webcal:")}>Otvori u kalendaru (Apple/Outlook)</a>
            <a class="btn ghost sm" style="text-decoration:none" target="_blank" rel="noopener" href={googleCalUrl(pub.id)}>Dodaj u Google Calendar</a>
          </div>
        </>
      )}
    </Modal>
  );
}
